import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {DisposeBag} from "../modules/DisposeBag";
import {ActivityTypeDto} from "../model/ActivityTypeDto";

class ActivityTypeSelectController implements IComponentController {
    records: ActivityTypeDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllActivityType(() => this.records, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
        this.$dataHub.activityTypeSubscribeAndQuery().then(ret => this.records = ret);
    };

    $onInit(): void {
    }

    $onDestroy() {
        this.disposeBag.finalize();
    }
}

export default angular.module('component.activityTypeSelect', [])
    .component('activityTypeSelect', {
        template: require('./ActivityTypeSelect.html'),
        controller: ActivityTypeSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
